import React, { useRef } from 'react'
import { Formik } from 'formik'
import { withRouter, RouteComponentProps } from 'react-router'

import { Modal } from 'src/components/Ant'
import { Report } from 'src/store/ducks/reports/types'

import objectToQueryString from 'src/helpers/object-to-query-string'
import useGetReportParams from '../../useGetReportParams'

interface Props {
  activeReport: Report
  toggleModal: () => void
  visibleModal: boolean
}

const defaultReportSelect: Report = {
  description: '',
  filters: '',
  name: '',
  report_class: '',
  report_data_id: -1,
  report_type: null,
  resources: null
}

function ReportParametersModal({
  activeReport,
  history,
  toggleModal,
  visibleModal
}: Props & RouteComponentProps): JSX.Element {
  const refFormik = useRef(undefined)

  const { name, report_class, report_data_id } =
    activeReport || defaultReportSelect

  const { initialValues, render, validationSchema } =
    useGetReportParams(report_class)

  return (
    <Modal
      destroyOnClose
      okText="web.reports.modal.action"
      onCancel={() => toggleModal()}
      onOk={() => {
        refFormik.current.submitForm()
      }}
      title={<span>{`${report_data_id} - ${name}`}</span>}
      visible={visibleModal}
      width={350}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={values => {
          delete values.reason
          delete values.service
          delete values.payment_resource
          delete values.cost_center
          delete values.billing_type
          delete values.contract
          delete values.reference
          delete values.target

          const queryString = objectToQueryString(values)
          toggleModal()
          history.push(`/management/reports/${report_data_id}${queryString}`)
        }}
        ref={refFormik}
        render={render}
        validateOnBlur
        validationSchema={validationSchema}
      />
    </Modal>
  )
}

export default withRouter(ReportParametersModal)
